import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/sys/cfg/line/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 添加
export function addInfo(data) {
  return request.send({
    url: `/pmy/sys/cfg/line`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 编辑
export function editInfo(data) {
  return request.send({
    url: `/pmy/sys/cfg/line`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 删除
export function deleteInfo(lineId) {
  return request.send({
    url: `/pmy/sys/cfg/line?lineId=${lineId}`,
    method: "delete"
  });
}
// 获取指定公司的线路列表（用于下拉选择）
export function getBaseLine(companyId) {
  return request.send({
    url: `/pmy/sys/cfg/line/base?companyId=${companyId}`,
    method: "get"
  });
}
// 获取线路列表（用于下拉选择）
export function getLine() {
  return request.send({
    url: `/pmy/sys/cfg/line/base`,
    method: "get"
  });
}
